import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { Container } from 'components/domain/container';
import { ListContainer } from 'components/domain/recommendations/Recommendations.common';
import { FdrTeaserCard } from 'components/domain/fdr-teaser-card';
import { FdrImage } from '@hotelplan/fdr.regular.basis.fdr-image';

export const FdrInfoSectionWrapper = styled.div(
  sx2CssThemeFn({
    bg: 'paperGrey',
    color: 'black',
    fontSize: 2,
  })
);

export const FdrTextContainer = styled(Container)(
  ({ theme }) => theme.text.richText,
  sx2CssThemeFn({
    pt: ['35px', '85px'],
    pb: ['55px', '65px'],
    '.lead-text': {
      display: 'block',
      mb: 3,
      fontWeight: 700,
      maxWidth: [null, '818px'],
      mx: [null, 'auto'],
      'ul,ol': {
        fontSize: [2],
      },
    },
  })
);

export const FdrBlogArticlesWrapper = styled.div(
  sx2CssThemeFn({
    bg: 'paperGrey',
    '> div': {
      pr: [3, '40px'],
    },
  })
);

export const FdrBlogArticles = styled(ListContainer)(
  sx2CssThemeFn({
    maxWidth: '1480px',
    '.main-title': {
      mb: ['32px', '60px'],
    },
    '.articles': {
      maxWidth: '1440px',
      m: 'auto',
    },
  })
);

export const FdrBlogArticleImage = styled(FdrTeaserCard)({
  '.card-title': {
    color: 'white',
  },
});

export const FdrAuthorDisrupterWrapper = styled.div({
  position: 'absolute',
  top: '15px',
  left: 0,
  '.author-content': {
    alignItems: 'flex-end',
  },
});

export const FdrAuthorDisrupterContent = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: 'goldLight',
    width: 'fit-content',
  })
);

export const FdrAuthorImage = styled(FdrImage)({
  borderRadius: '50%',
  objectFit: 'cover',
  width: '65px',
  height: '65px',
});

export const FdrAuthorText = styled.div({
  marginLeft: '20px',
  fontSize: '12px',
  '.employee-name': {
    maxWidth: '100px',
    fontWeight: 'bold',
  },
});
